import React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DynamicTableForJson from "../../../../../data/DynamicTable/dynamicTableForJson";
import { SDLSUrl } from "../../../../../config";
import Form from "./form";

const base_url = SDLSUrl.uri;

const CustomerDevicesTable = () => {
  const navigate = useNavigate();
  const customerId = localStorage.getItem("CustomerId");

  const actions = {
    entity: "Customer Devices",
    isSubright: true,
    showStatus: false,
    add: {
      key: "ADD",
      button_name: "Link Device",
      Show_Button: true,
      permission: "CreatePermission",
    },
    edit: {
      key: "EDIT",
      button_name: "Remove Device",
      Show_Button: true,
      permission: "CreatePermission",
    },
    
    
    dataObject: {
      ignoreFields: ["CreateDate", "UpdateDate", "Status", "HonorStatus"],
      objectName: "deviceRegistry",
      parameters: { customerId: parseInt(customerId, 10) },
      inputObjectName: "param",
    },
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => navigate(-1)} variant="contained">
          Back to Customer
        </Button>
      </Box>

      <DynamicTableForJson
        title="Customer Devices"
        subtitle="Devices linked to this customer"
        FormComponent={Form}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default CustomerDevicesTable;